<script setup lang="ts">
defineProps<{
  backgroundColor?: string;
  padding?: string;
  align?: 'full' | 'container' | 'container-left';
}>()
</script>

<template>
  <section 
    class="vox-section" 
    :class="[
      { 'align-full': align === 'full' },
      { 'align-container-left': align === 'container-left' }
    ]"
    :style="{ 
      backgroundColor: backgroundColor || 'transparent',
      padding: padding || '100px 0'
    }"
  >
    <div :class="align === 'full' ? 'full-width' : 'container'">
      <slot />
    </div>
  </section>
</template>

<style scoped>
.vox-section {
  width: 100%;
  position: relative;
}

.align-container-left .container {
  max-width: none;
  padding-left: calc((100vw - var(--container-width)) / 2 + 40px);
  padding-right: 0;
  margin-left: 0;
}

@media (max-width: 1595px) {
  .align-container-left .container {
    padding-left: 40px;
  }
}

.align-full {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

@media (max-width: 767px) {
  .vox-section {
    padding: 60px 0 !important;
  }
}
</style>
